/**
 * Per-attempt idempotency key for `X-Source-Key`.
 *
 * One key identifies ONE submit attempt: retrying it (a lost response, a token
 * refresh mid-POST) returns the row the first try created instead of a second
 * money entry. The caller must therefore mint a fresh key whenever the entry
 * itself changes — see SellerEntryDrawer.
 *
 * `crypto.randomUUID` needs a secure context; plain-http LAN dev falls back to
 * a random token of the same shape the server's SOURCE_KEY_RE accepts.
 */
export function newSourceKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  return [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
}
